import {Configuration} from "@api-clients/runtime";
import {ProveLineItem} from "@api-clients/prove/schema/ProveLineItem";
import {ProveCampaign} from "@api-clients/prove/schema/ProveCampaign";

export class CreateProveLineItemApi {

    static async execute(
        configuration: Configuration,
        campaign: ProveCampaign,
        lineItem: ProveLineItem
    ): Promise<ProveLineItem> {
        const response = await fetch(`${configuration.basePath}/a360/v1/prove/campaigns/${campaign.id}/insertion-orders/${campaign.insertionOrder!.id}/line-items`, {
            method: 'POST',
            headers: configuration.headers,
            body: JSON.stringify(lineItem)
        });

        return response.json();
    }

}
